export const EmailPreferenceId = {
    SalePurchaseConfirmation: 1,
    ContractPaymentConfirmation: 2,
    CampaignExpiringSecondReminder: 3,
    CampaignExpiringThirdReminder: 4,
    CampaignExpiredSecondReminder: 5,
    CampaignExpiredThirdReminder: 6
};
